import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { ApiAbstractService } from './api-abstract.service';
var AdminService = /** @class */ (function (_super) {
    tslib_1.__extends(AdminService, _super);
    function AdminService(httpClient) {
        var _this = _super.call(this, environment.API_BASE) || this;
        _this.httpClient = httpClient;
        _this.apiBase = environment.API_BASE;
        return _this;
    }
    AdminService.prototype.getDomains = function () {
        return this.httpClient.get(this.buildUrl("/api/domains/", { limit: 999, offset: 0 })).pipe(map(function (res) { return res.results; }));
    };
    AdminService.prototype.getAccounts = function (payload) {
        return this.httpClient.get(this.buildUrl("/api/users/", payload));
    };
    AdminService.prototype.createAccount = function (payload) {
        var url = this.apiBase + "/api/users/";
        var body = {
            name: payload.name,
            email: payload.email,
            roles: payload.roles
        };
        return this.httpClient.post(url, body);
    };
    AdminService.prototype.getAuthRoles = function () {
        var url = this.apiBase + "/api/auth_roles/";
        return this.httpClient.get(url);
    };
    AdminService.prototype.updateRoles = function (request) {
        var url = this.apiBase + "/api/users/" + request.oauthId + "/roles/";
        var body = {
            roles: request.roles
        };
        return this.httpClient.patch(url, body);
    };
    AdminService.prototype.accountBatchUpload = function (payload) {
        var url = this.apiBase + "/api/users/bulk_create/";
        var formData = new FormData();
        formData.append('file', payload.file);
        return this.httpClient.post(url, formData);
    };
    AdminService.prototype.getPermissions = function (payload) {
        var url = this.apiBase + "/api/permissions/?";
        url += payload.limit ? "limit=" + payload.limit : '';
        url += payload.offset ? "&offset=" + payload.offset : '';
        url += payload.sort ? "&sort=" + payload.sort : '';
        return this.httpClient.get(url);
    };
    AdminService.prototype.getConfig = function (key) {
        var url = this.apiBase + "/api/appconfig/" + key + "/";
        return this.httpClient.get(url);
    };
    AdminService.prototype.updateConfig = function (payload) {
        var url = this.apiBase + "/api/appconfig/" + payload.key + "/";
        var body = payload.value ? {
            key: payload.key,
            value: payload.value,
        } : {
            key: payload.key,
            jsonValue: payload.jsonValue,
        };
        return this.httpClient.put(url, body);
    };
    AdminService.prototype.unlockUser = function (payload) {
        var url = this.apiBase + "/api/users/" + payload.oauthId + "/unlock";
        return this.httpClient.patch(url, null);
    };
    AdminService.prototype.checkLastLogin = function (oAuthId) {
        var url = this.apiBase + "/api/users/" + oAuthId + "/last_login";
        return this.httpClient.get(url);
    };
    return AdminService;
}(ApiAbstractService));
export { AdminService };
